/**
 * icon-patrol-detection.js
 */

import React from 'react';
import { Types } from 'utils/constants';
import Icon from 'components/icon';


export const getIconName = (workMode, patrolType, fulfillmentState) => {
  // If this is a non-performed deployment, use a special icon
  if (fulfillmentState === Types.FulfillmentState.DogNotDeployed || 
      fulfillmentState === Types.FulfillmentState.CancelledEnroute) {
    return 'home-remove-outline'; // This is the cancellation icon
  }

  const detectionTypes = {
    [Types.WorkMode.DETECTION]: 'detection',
  };
  const patrolTypes = {
    [Types.Patrol.AGILITY]: 'patrol-agility',
    [Types.Patrol.APPREHENSION]: 'patrol-apprehension',
    [Types.Patrol.BUILDING_SEARCH]: 'patrol-building-search',
    [Types.Patrol.EVIDENCE_SEARCH]: 'patrol-evidence-search',
    [Types.Patrol.HUMAN_SEARCH]: 'patrol-human-search',
    [Types.Patrol.OBEDIENCE]: 'patrol-obedience',
    [Types.Patrol.TRACKING]: 'patrol-tracking',
    [Types.Patrol.OTHER]: 'patrol-other',
    [Types.Patrol.NONSEARCH]: 'patrol-non-search',
    [Types.Patrol.SCENARIO]: 'patrol-scenario'
  };

  if (workMode === Types.WorkMode.DETECTION) {
    return detectionTypes[workMode.toString()];
  } else if (workMode === Types.WorkMode.PATROL) {
    return patrolTypes[patrolType.toString()];
  } else {
    return 'help';
  } 
}


export default function IconPatrolDetection(props) {
  const { workMode, patrolType, fulfillmentState, style, className } = props;

  return <Icon
    type={getIconName(workMode, patrolType, fulfillmentState)}
    style={style}
    className={className}
  />;
}